import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactElement } from 'react';
import { RouterProvider } from 'react-router/dom';
import { queryClient } from '@/app/query-client';
import { router } from '@/app/router';
import { SessionGate } from '@/app/session-gate';

export function App(): ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionGate>
        <RouterProvider router={router} />
      </SessionGate>
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
